<template>
  <button type="button" class="btn btn-success" @click="open">
    <font-awesome-icon icon="plus" />上傳派件明細表
  </button>
  <!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog"
    header="上傳派件明細表"
    :modal="true"
    class="p-fluid"
    :style="{ width: '80vw', 'min-height': '100vh' }"
    :position="position"
  >
    <PrimeFileUpload
      name="demo[]"
      :customUpload="true"
      @uploader="myUploader"
      @select="select"

    :chooseLabel="'選擇檔案'"
    :uploadLabel="'上傳'"
    :cancelLabel="'取消'"

    />

    <p v-html="message" style="color: red"></p>
  </PrimeDialog>
</template>

<script>
import * as XLSX from "xlsx"; // vue3可用此引入
import service from "../service/Appservice";
export default {
  props: {
    msg: String,
  },
  data() {
    return {
      data: null,
      isShowDialog: false,
      excelData: [],
      uploadData: [],
      message: "",
    };
  },
  inject: ["params"],
  computed: {
    user() {
      return this.$store.state.user;
    },
    agentNo() {
      return this.$store.state.user?.agentNo;
    },
    getHeader() {
      return this.excelData.slice(0, 1);
    },
    getBody() {
      return this.excelData.slice(1);
    },
  },
  service: null,
  created() {
    this.service = new service();
  },

  methods: {
    change(event) {
      const files = event.target.files;

      // 讀取表格
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        const workbook = XLSX.read(ev.target.result, {
          type: "binary",
        });
        const wsname = workbook.SheetNames[0];
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);
        console.log(ws); // 轉換成json的數據
        // const m = dealExcel(ws) // ...對數據進行自己需要的操作
        //console.log(m)
      };
      fileReader.readAsBinaryString(files[0]);
    },
    select(event) {
      console.log(event.files[0]);
      //event.files == files to upload
      var self = this;
      var reader = new FileReader();
      reader.onload = () => {
        var fileData = reader.result;
        var wb = XLSX.read(fileData, {
          type: "binary",
          cellText: false,
          cellDates: true,
        });

        let sheetName = wb.SheetNames[0];

        var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
          header: 1,
          raw: false,
          dateNF: "yyyy-mm-dd",
        });

        console.log(rowObj);
        //self.excelData = JSON.stringify(rowObj)
        self.excelData = JSON.parse(JSON.stringify(rowObj));
        console.log(self.excelData);
        self.excelToObj();
      };
      reader.readAsBinaryString(event.files[0]);
    },

    excelToObj() {
      var self = this;
      this.getBody.forEach(function (item) {
        let o = {
          awB_Date: null,
          preClearanceCustomsBarCode: null,
          awB_No: null,
          transfer_AWB_No: null,
          impRec_Company: null,
          impRec_Address: null,
          impRec_Contact: null,
          impRec_Phone: null,
          collection_Income: null,
          predictPiece: null,
          actual_Weight: null,
          other_Note: null,
          areaCode: null,
          sendCode: null,
        };
        if (item.length > 0) {
          item.forEach(function (value, index) {
            if (index == 0) {
              o.awB_Date = value;
            } else if (index == 1) {
              o.preClearanceCustomsBarCode = value;
            } else if (index == 2) {
              o.awB_No = value;
            } else if (index == 3) {
              o.transfer_AWB_No = value;
            } else if (index == 12) {
              o.areaCode = value;
            } else if (index == 13) {
              o.sendCode = value;
            }
          });
          self.uploadData.push(o);
        }
      });

      console.log(self.uploadData);

      self.message = "共" + self.uploadData.length + "筆提單要上傳!";
    },

    myUploader(event) {
      console.log(event);
      var self = this;
      this.service.updateSendReport(self.uploadData).then((data) => {
        console.log(data);
        alert("上傳更新成功");
        self.message = "";
      });
      //event.files == files to upload
    },
    ////////搜尋/////////////////////////////////////
    open() {
      this.isShowDialog = true;
    },
  },
};
</script>
 